/**
 * @generated SignedSource<<1ae864c927466fb5ab620ca8c3591dd2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProjectNoteQuery$variables = Record<PropertyKey, never>;
export type ProjectNoteQuery$data = {
  readonly current_account: {
    readonly id: number;
    readonly user_accounts: ReadonlyArray<{
      readonly id: number;
      readonly user: {
        readonly account_id: number;
        readonly email: string;
        readonly first_name: string | null | undefined;
        readonly id: number;
        readonly last_name: string | null | undefined;
      };
    }>;
  } | null | undefined;
};
export type ProjectNoteQuery = {
  response: ProjectNoteQuery$data;
  variables: ProjectNoteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "accounts",
    "kind": "LinkedField",
    "name": "current_account",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "user_accounts",
        "kind": "LinkedField",
        "name": "user_accounts",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "users",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "first_name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "last_name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "account_id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectNoteQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProjectNoteQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6981e0707a1f664a661114338ba32f62",
    "id": null,
    "metadata": {},
    "name": "ProjectNoteQuery",
    "operationKind": "query",
    "text": "query ProjectNoteQuery {\n  current_account {\n    id\n    user_accounts {\n      id\n      user {\n        id\n        first_name\n        last_name\n        account_id\n        email\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6b05e610d7960ce7d30f53e070f14de7";

export default node;
